import { render, staticRenderFns } from "./recordRankingList.vue?vue&type=template&id=475d793d&scoped=true&"
import script from "./recordRankingList.vue?vue&type=script&lang=js&"
export * from "./recordRankingList.vue?vue&type=script&lang=js&"
import style0 from "./recordRankingList.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./recordRankingList.vue?vue&type=style&index=1&id=475d793d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d793d",
  null
  
)

export default component.exports